//#region \0@oxc-project+runtime@0.151.0/helpers/esm/checkPrivateRedeclaration.js
function _checkPrivateRedeclaration(e, t) {
	if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
//#endregion
export { _checkPrivateRedeclaration as default };
